import moment from 'moment';

/* Форматы вывода режима «Портфолио» (п. 9 ТЗ).
   Дата загрузки файла приходит как «dd/mm/yyyy HH:MM:SS», размер — в байтах,
   показатель заполнения — числом (в старых ответах с дробной частью).
   Незаполненный текст — null или пустая строка: клиент их не различает. */

export const isEmpty = (value) => value == null || String(value).trim() === '';

// Дата — ДД.ММ.ГГГГ. Нераспознанное значение выводим как есть, а не «Invalid date».
export const formatDate = (value) => {
  if (isEmpty(value)) return null;
  const formats = ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD.MM.YYYY'];
  const date = moment(String(value), formats, true);
  return date.isValid() ? date.format('DD.MM.YYYY') : value;
};

// Размер файла — в килобайтах до 1 МБ, дальше в мегабайтах с одним знаком («1,2 МБ»).
export const formatSize = (bytes) => {
  const num = Number(bytes);
  if (!Number.isFinite(num) || num < 0) return null;
  if (num < 1024 * 1024) return `${Math.max(1, Math.round(num / 1024))} КБ`;
  return `${(num / (1024 * 1024)).toFixed(1).replace('.', ',')} МБ`;
};

// Показатель заполнения — целое число процентов в пределах 0–100.
export const formatPercent = (value) => {
  const num = Math.round(Number(value));
  if (!Number.isFinite(num)) return 0;
  return Math.min(100, Math.max(0, num));
};

// Расширение имени файла в нижнем регистре, без точки; пустая строка, если его нет.
export const fileExtension = (name) => {
  const parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

// Подпись вида файла для квадратного значка: расширение прописными, не длиннее 4 знаков.
export const fileKind = (name) => (fileExtension(name) || 'file').toUpperCase().slice(0, 4);
